<template>
  <v-container>
    <v-dialog v-model="dialog_value.show" max-width="700px" @click:outside="$store.commit('close_add_cast_dialog')">
      <v-card>
        <v-toolbar flat color="primary" dark class="justify-center">
          <v-toolbar-title>افزودن عامل جدید</v-toolbar-title>
        </v-toolbar>
        <validation-observer v-slot="{ valid }" ref="observer">
          <v-card-text>
            <Cast :cast="dialog_value.user"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" outlined @click="$store.commit('close_add_cast_dialog')">
              لغو
            </v-btn>
            <v-btn color="secondary" :disabled="!valid" @click="add_cast">
              افزودن
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Cast from "@/components/submit/steps/Cast";
import {digits, numeric, required} from "vee-validate/dist/rules";
import {mapState} from "vuex";
import {extend,ValidationObserver,ValidationProvider} from "vee-validate";

extend('phone_number', {
  validate: value => {
    return value.length === 11 && /^09[0-9]{9}$/.test(value);
  },
  message: 'شماره تلفن همراه باید 11 رقمی باشد.'
});

extend("required", {
  ...required,
  message: "پر کردن این قسمت اجباریست",
});

extend("digits", {
  ...digits,
  message: "کد ملی وارد شده صحیح نمیباشد",
});

extend("numeric", {
  ...numeric,
  message: "لطفا سن درست را وارد کنید",
});
extend("fixed_phone", {
  ...numeric,
  message: "تلفن وارد شده صحیح نمیباشد",
});

export default {
  name: "AddCastDialogAdmin",
   data: () => {
    return {
    }
  },
  computed: {
    ...mapState({
      dialog_value: state => state.Admin.settings.add_cast_dialog
    }),
  },
  components: {
    Cast,
    ValidationObserver,
    ValidationProvider,
  },
  methods: {
    add_cast() {
      this.$store.dispatch('add_cast_admin')
    },
  },
    watch: {
    show: function () {
      console.log(this)
      this.$refs.observer.reset();
    },
  }

}

</script>

<style scoped>

</style>